<!-- Topbar -->
<div gsTopbarHeight class="grid transition-all duration-200" [style.grid-template-rows]="topbarOpen() ? '1fr' : '0fr'">
  <div class="overflow-hidden">
    <header-topbar (closeTopbar)="toggleTopbar(false)"></header-topbar>
  </div>
</div>
@let mainbar = headerService.mainbarConfig();
@let defaultMainbar = headerService.DEFAULT_CONFIG.header?.mainbar;
@let defaultMenubar = headerService.DEFAULT_CONFIG.header?.menubar;
@let initData = infoService.init();
@let headerBackgroundColor = config.config()?.header?.backgroundColor ?? headerService.DEFAULT_CONFIG.header?.backgroundColor;
@let menubar = headerService.menubarConfig();
@let headerPadding = config.config()?.header?.padding ?? headerService.DEFAULT_CONFIG.header?.padding;
<nav
  id="site-navigation"
  [attr.aria-label]="'header.aria.navigation' | translate"
  class="relative z-50 grid grid-cols-[8rem_1fr] lg:grid-cols-[12rem_1fr] xl:grid-cols-[18rem_1fr]"
  [ngClass]="[styleService.getColorClass(headerBackgroundColor, 'bg'), headerService.useContainer() ? 'container mx-auto' : '']"
  [gsResponsive]="{ padding: headerPadding }"
>
  <!-- Mainbar -->
  @let search = mainbar?.search;
  @let actions = mainbar?.actions;

  @let isMobile = styleService.isMobile('md');
  @if (mainbar && mainbar.active && initData && initData.logo) {
    <!-- LOGO -->
    @if (mainbar.logo?.active) {
      <a
        [href]="headerService.logoLink()"
        [attr.aria-label]="'header.aria.homepage' | translate"
        class="focus-visible:ring-primary-main flex w-32 justify-start focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 lg:w-48 xl:w-72"
        [ngClass]="{
          'row-span-2': mainbar.logo?.useFullHeight,
          'lg:pl-6': !headerService.useContainer()
        }"
      >
        <span
          class="relative block h-8 w-full"
          [class.lg:h-40]="mainbar.logo?.useFullHeight"
          [class.lg:h-28]="!mainbar.logo?.useFullHeight"
        >
          @for (p of [initData.logo]; track p?.medium ?? 'nopic') {
            <img
              class="object-contain object-left"
              [ngSrc]="p.medium"
              [ngSrcset]="imageService.DEFAULT_SRCSET"
              [loaderParams]="imageService.getLoaderParams(p)"
              sizes="(max-width: 991px) 128px, (max-width: 1199px) 192px, 288px"
              fill
              priority
              alt="Logo"
            />
          }
        </span>
      </a>
    } @else if (initData?.companyInfo?.contact?.company) {
      <span
        class="flex h-8 max-w-64 shrink items-center text-2xl font-bold tracking-tight md:pr-9"
        [ngClass]="[styleService.getColorClass(menubar?.textColor ?? defaultMenubar?.textColor ?? 'dark-main', 'text')]"
      >
        {{ initData?.companyInfo?.contact?.company }}
      </span>
    }
    <div class="flex flex-row items-center justify-start text-xl lg:text-2xl">
      <!-- SEARCH -->
      <typeahead #typeaheadRef [showFullSize]="!mainbar?.search?.showAsModal" [borderRadius]="mainbar?.search?.borderRadius"></typeahead>
      <span class="flex w-full flex-row justify-end lg:justify-start">
        @if (search && search.active && search.icon) {
          @let searchLabel = 'header.actionButtons.search' | translate;
          <button
            class="border-medium-main focus-visible:ring-primary-main flex cursor-pointer flex-row items-center justify-start gap-6 bg-transparent text-left duration-200 focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 lg:ml-10 lg:w-full lg:max-w-64 lg:min-w-36 lg:border-b lg:pb-2"
            [ngClass]="[
              styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text'),
              styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')
            ]"
            [aria-label]="searchLabel"
            [title]="searchLabel"
            [style.marginRight.px]="isMobile ? 22 : (actions?.gap ?? defaultMainbar?.actions?.gap ?? 15)"
            (click)="typeaheadRef.showSearchInput.set(true)"
          >
            <gs-icon [iconName]="search.icon.name" [iconWeight]="search.icon.weight" [animation]="search.icon.animation"></gs-icon>
            <p class="text-medium-main hidden w-full lg:inline">{{ searchLabel }}</p>
          </button>
        }
      </span>
      <!-- ACTIONS -->
      @let actionsContrastColor = colorService.getContrastColorOf(actions?.iconColor ?? 'secondary-main');
      @let actionLinkList = headerService.actionLinks();
      <span
        class="flex flex-row lg:mr-6"
        [style.gap.px]="isMobile ? 22 : (actions?.gap ?? defaultMainbar?.actions?.gap ?? 15)"
        [ngClass]="[styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text')]"
      >
        @if (actionLinkList) {
          @for (action of headerService.mainbarActions() | keyvalue | orderBy: 'desc' : 'value.orderIndex'; track action.key) {
            @let actionVal = action.value;
            @let shownIfLoggedIn =
              headerService.CONFIG_HEADER_ACTIONS_NEEDS_LOGIN.includes(action.key) ? headerService.isLoggedIn() : true;
            @let shownIfNotLoggedIn =
              headerService.CONFIG_HEADER_ACTIONS_WITHOUT_LOGIN.includes(action.key) ? !headerService.isLoggedIn() : true;
            @let shownIfWebshop = headerService.CONFIG_HEADER_ACTIONS_NEEDS_WEBSHOP.includes(action.key) ? system.isWebshop : true;
            @let shownIfInquiry = headerService.CONFIG_HEADER_ACTIONS_NEEDS_INQUIRY.includes(action.key) ? !!initData?.hasInquiry : true;
            @if (actionVal && shownIfLoggedIn && shownIfNotLoggedIn && shownIfWebshop && shownIfInquiry) {
              @let label = 'header.actionButtons.' + action.key | translate;
              <!-- The configured per-breakpoint visibility is resolved in CSS, so the wrapper is `display: contents` while active and `none` otherwise. -->
              <span [gsResponsive]="{ visible: actionVal.active ?? false }">
                @if (actionLinkList[action.key]) {
                  <a
                    class="group focus-visible:ring-primary-main relative cursor-pointer duration-200 focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                    [href]="actionLinkList[action.key]"
                    [aria-label]="label"
                    [title]="label"
                    [ngClass]="[styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')]"
                  >
                    <ng-container *ngTemplateOutlet="innerActionRef"></ng-container>
                  </a>
                } @else {
                  <button
                    class="group focus-visible:ring-primary-main relative cursor-pointer duration-200 focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                    (click)="handleActionClick(action.key, $event)"
                    [aria-label]="label"
                    [title]="label"
                    [ngClass]="[styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')]"
                  >
                    <ng-container *ngTemplateOutlet="innerActionRef"></ng-container>
                  </button>
                }
              </span>
              <ng-template #innerActionRef>
                @if (actionVal.icon) {
                  <gs-icon
                    [iconName]="actionVal.icon.name"
                    [iconWeight]="actionVal.icon.weight"
                    [animation]="actionVal.icon.animation"
                  ></gs-icon>
                }
                @if (action.key === 'watchlist' || action.key === 'shoppingcart' || action.key === 'inquiry_shoppingcart') {
                  <span
                    class="absolute -top-1 -right-2.5 flex size-5 items-center justify-center rounded-full text-center text-xs"
                    [ngClass]="[
                      styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'bg'),
                      styleService.getColorClass(actionsContrastColor, 'text')
                    ]"
                  >
                    {{
                      (action.key === 'watchlist'
                        ? watchlist.amount
                        : action.key === 'shoppingcart'
                          ? basket.count
                          : basket.requestListCount) ?? 0
                    }}
                  </span>
                }
              </ng-template>
            }
          }
        }
      </span>
      <!-- MYCHAINSTORE DESKTOP -->
      @let myChainstore = mainbar.myChainstore;
      @let myChainstoreMode = myChainstore?.displayMode ?? 'both';
      @if (myChainstore && myChainstore.active && myChainstore.icon && myChainstoreMode !== 'sidemenu') {
        <button
          class="border-medium-main group focus-visible:ring-primary-main h-12 cursor-pointer flex-row gap-4 border-l bg-transparent px-6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
          [attr.aria-expanded]="myChainstoreService.panelOpen()"
          aria-haspopup="dialog"
          (click)="myChainstoreService.openPanel()"
          [ngClass]="[
            styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text'),
            styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:'),
            myChainstoreMode === 'header' ? 'flex' : 'hidden lg:flex'
          ]"
        >
          <gs-icon
            [iconName]="myChainstore.icon.name"
            [iconWeight]="myChainstore.icon.weight"
            [animation]="myChainstore.icon.animation"
          ></gs-icon>
          <span class="text-dark-main hidden flex-col justify-between leading-7 lg:flex">
            <h5>{{ 'header.mainbar.myChainstore.label' | translate }}</h5>
            <p class="text-base text-nowrap group-hover:underline">
              {{ myChainstoreService.current()?.name ?? ('header.mainbar.myChainstore.notSelected' | translate) }}
              <gs-icon iconName="note-pencil" iconWeight="light" class="pl-2"></gs-icon>
            </p>
          </span>
        </button>
      }
      <!-- LANGUAGE DESKTOP -->
      @let language = mainbar.language;
      @let pageLanguages = headerService.pageLanguages();
      @if (language && language.active && pageLanguages) {
        <div
          class="relative hidden lg:flex"
          (mouseenter)="headerService.onLangMenuEnter()"
          (mouseleave)="headerService.onLangMenuLeave()"
          (focusout)="headerService.onLangMenuFocusOut($event)"
          (keydown)="headerService.onLangMenuKeydown($event)"
        >
          <button
            class="border-medium-main focus-visible:ring-primary-main flex h-12 cursor-pointer flex-row items-center gap-2 border-l bg-transparent px-6 py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
            [attr.aria-expanded]="headerService.langMenuOpen()"
            aria-haspopup="true"
            [attr.aria-label]="'header.language.select' | translate"
            (click)="headerService.toggleLangMenu()"
          >
            @let lang = languageService.currentLang;
            @if (lang) {
              @let languageName = lang.split('-').join('') | translate;
              <img
                [src]="headerService.flagurl + lang + '.png'"
                [alt]="languageName"
                class="w-16 object-contain pt-0.5"
                [title]="languageName"
              />
            }
            <gs-icon
              [iconName]="headerService.langMenuOpen() ? 'caret-up' : 'caret-down'"
              iconWeight="light"
              class="text-dark-main text-base"
            ></gs-icon>
          </button>
          @if (headerService.langMenuOpen()) {
            <ul
              class="absolute top-full right-0 z-50 min-w-48 overflow-hidden rounded-b-md shadow-md"
              [class]="styleService.getColorClass(headerBackgroundColor, 'bg')"
              role="menu"
            >
              @for (entry of pageLanguages | keyvalue; track entry.key) {
                @let entryName = entry.key.split('-').join('') | translate;
                <li role="none">
                  <button
                    role="menuitem"
                    class="focus-visible:ring-primary-main flex w-full cursor-pointer items-center gap-3 bg-transparent px-4 py-2.5 text-left transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
                    [ngClass]="{
                      'bg-light-shade font-semibold': entry.key === languageService.currentLang,
                      'hover:bg-light-shine': entry.key !== languageService.currentLang
                    }"
                    (click)="headerService.changeLanguage(entry.key)"
                  >
                    <img [src]="headerService.flagurl + entry.key + '.png'" [alt]="entryName" class="w-8 object-contain" />
                    <span class="text-dark-main text-sm">{{ entryName }}</span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      }
      <!-- BURGER-BUTTON MOBILE -->
      <ng-container [ngTemplateOutlet]="burgerButtonRef" [ngTemplateOutletContext]="{ showOnlyMobile: true }" />
    </div>
  }
  <!-- Menubar -->
  @let menuItems = headerService.dropdownPages();
  @if (menubar && menuItems && menuItems.length > 0) {
    @let menubarAlignment = menubar.alignment ?? defaultMenubar?.alignment ?? 'left';
    @let menuItemFont = styleService.getFontClasses(menubar.font);
    @let menuItemGap = menubar.gapBetweenItems ?? defaultMenubar?.gapBetweenItems;
    @let menuColors =
      styleService.getColorClass(menubar.textColor ?? defaultMenubar?.textColor ?? 'dark-main', 'text') +
      styleService.getColorClass(menubar.backgroundColor ?? defaultMenubar?.backgroundColor ?? 'light-main', 'bg');
    @let dropdownMenu = menubar.dropdownMenu;
    @let defaultDropdownMenu = defaultMenubar?.dropdownMenu;
    @let dropdownMenuItemFont =
      styleService.getFontClasses(dropdownMenu?.font ?? defaultDropdownMenu?.font ?? menubar.font ?? defaultMenubar?.font);
    @let dropdownMenuItemColors =
      styleService.getColorClass(dropdownMenu?.textColor ?? menubar.textColor ?? defaultMenubar?.textColor ?? 'dark-main', 'text') +
      styleService.getColorClass(menubar.backgroundColor ?? defaultMenubar?.backgroundColor ?? 'light-main', 'bg');
    <ul
      class="navbar-nav hidden w-full flex-row items-center lg:flex"
      [ngClass]="[
        menuColors,
        menuItemFont,
        headerService.useContainer() ? 'container mx-auto' : 'px-6',
        mainbar?.logo?.useFullHeight ? '' : 'col-span-2',
        menubarAlignment === 'center'
          ? 'justify-center'
          : menubarAlignment === 'right'
            ? 'justify-end'
            : menubarAlignment === 'justify-between'
              ? 'justify-between'
              : 'justify-start'
      ]"
      [style.gap.px]="menuItemGap"
      [style.fontSize.px]="menubar.textSize ?? defaultMenubar?.textSize"
    >
      @let burgerKeepActiveOnDesktop = !!(menubar.burgerButton?.active && menubar.burgerButton?.keepActiveOnDesktop);
      <!-- BURGER-BUTTON DESKTOP (if option active) -->
      @if (burgerKeepActiveOnDesktop) {
        <li
          [style.paddingTop.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 15"
          [style.paddingBottom.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 15"
        >
          <ng-container [ngTemplateOutlet]="burgerButtonRef" [ngTemplateOutletContext]="{ showOnlyMobile: false }" />
        </li>
      }
      @let menuItemActiveClasses =
        styleService.getColorClass(menubar.activeTextColor ?? defaultMenubar?.activeTextColor ?? 'secondary-main', 'text') +
        styleService.getColorClass(menubar.activeBackgroundColor ?? defaultMenubar?.activeBackgroundColor ?? 'light-shade', 'bg');
      @let dropdownMenuActiveClasses =
        styleService.getColorClass(
          dropdownMenu?.activeTextColor ??
            defaultDropdownMenu?.activeTextColor ??
            menubar.activeTextColor ??
            defaultMenubar?.activeTextColor ??
            'secondary-main',
          'text'
        ) +
        styleService.getColorClass(
          dropdownMenu?.activeBackgroundColor ??
            defaultDropdownMenu?.activeBackgroundColor ??
            menubar.activeBackgroundColor ??
            defaultMenubar?.activeBackgroundColor ??
            'light-shade',
          'bg'
        );
      @let dropdownMenuHoverClasses =
        styleService.getColorClass(
          dropdownMenu?.activeTextColor ??
            defaultDropdownMenu?.activeTextColor ??
            menubar.activeTextColor ??
            defaultMenubar?.activeTextColor ??
            'secondary-main',
          'text',
          'hover:'
        ) +
        styleService.getColorClass(
          dropdownMenu?.activeBackgroundColor ??
            defaultDropdownMenu?.activeBackgroundColor ??
            menubar.activeBackgroundColor ??
            defaultMenubar?.activeBackgroundColor ??
            'light-shade',
          'bg',
          'hover:'
        );
      <!-- Hide the desktop menu items when the burger-button stays active on desktop (sidebar is used instead) -->
      @if (!burgerKeepActiveOnDesktop) {
        @for (menuItem of menuItems; track headerService.trackHeaderMenu(menuItem)) {
          @let isCurrentPage = headerService.isMenuItemOrChildActive(menuItem, system.currentRelativeLink());
          @let isExternalLink = menuItem.linkUrl?.startsWith('http');
          <!-- Menu items without a linked page arrive with linkUrl '' — href="" would resolve to the homepage -->
          @let hasLink = !!menuItem.linkUrl;
          @let hasChildren = menuItem.items.length > 0;
          @switch (menuItem.menuType) {
            @case (headerService.MenuType.MegaMenu) {
              <li
                class="nav-item dropdown dropdown-fullwidth"
                (mouseenter)="toggleDropdownOf(megamenuComp, $event, menuItem)"
                (mouseleave)="toggleDropdownOf(megamenuComp, $event, menuItem)"
              >
                <a
                  [attr.href]="hasLink ? menuItem.linkUrl : null"
                  [attr.target]="hasLink ? (isExternalLink ? '_blank' : (menuItem.linkTarget ?? '_self')) : null"
                  [attr.rel]="hasLink && isExternalLink ? 'noopener noreferrer' : null"
                  [attr.role]="!hasLink && hasChildren ? 'button' : null"
                  [attr.tabindex]="!hasLink && hasChildren ? 0 : null"
                  [attr.aria-haspopup]="!hasLink && hasChildren ? 'menu' : null"
                  [attr.aria-expanded]="!hasLink && hasChildren ? megamenuComp.opened() : null"
                  [attr.aria-disabled]="!hasLink && !hasChildren ? true : null"
                  [ngClass]="[
                    isCurrentPage ? menuItemActiveClasses : '',
                    !hasLink && !hasChildren ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
                  ]"
                  [style.paddingTop.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 15"
                  [style.paddingBottom.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 15"
                  (keydown)="headerService.handleDropdownKeydown(megamenuComp, $event, menuItem)"
                  class="focus-visible:ring-primary-main inline-flex items-center gap-1 pl-1 focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 md:gap-1.5"
                >
                  <span
                    [ngClass]="{
                      underline: isCurrentPage && (menubar.activeUnderlined ?? defaultMenubar?.activeUnderlined ?? false)
                    }"
                  >
                    {{ menuItem.label }}
                  </span>
                  @if (menuItem.items.length > 0) {
                    <gs-icon
                      [ngClass]="[
                        styleService.getColorClass(actions?.iconColor ?? defaultMainbar?.actions?.iconColor ?? 'secondary-main', 'text')
                      ]"
                      class="text-sm"
                      [iconName]="megamenuComp.opened() ? 'caret-up' : 'caret-down'"
                      iconWeight="light"
                    ></gs-icon>
                  }
                </a>
                <megamenu
                  #megamenuComp
                  [items]="menuItem.items"
                  [showItemPhotos]="false"
                  [showItemGlyphs]="false"
                  [menuItemClasses]="dropdownMenuItemFont + ' px-4 py-2'"
                  [menuItemColorClasses]="dropdownMenuItemColors"
                  [activeMenuItemClasses]="dropdownMenuActiveClasses"
                  [hoverMenuItemClasses]="dropdownMenuHoverClasses"
                  [activeUnderlined]="
                    dropdownMenu?.activeUnderlined ??
                    defaultDropdownMenu?.activeUnderlined ??
                    menubar.activeUnderlined ??
                    defaultMenubar?.activeUnderlined ??
                    false
                  "
                  [menuClasses]="styleService.getColorClass(headerBackgroundColor, 'bg') + ' shadow-lg w-full pt-4 pb-2'"
                  [style.fontSize.px]="dropdownMenu?.textSize ?? defaultDropdownMenu?.textSize"
                ></megamenu>
              </li>
            }
            @case (headerService.MenuType.Dropdown) {
              <li
                class="nav-item dropdown"
                (mouseenter)="toggleDropdownOf(dropdownComp, $event, menuItem)"
                (mouseleave)="toggleDropdownOf(dropdownComp, $event, menuItem)"
              >
                <a
                  [attr.href]="hasLink ? menuItem.linkUrl : null"
                  [attr.target]="hasLink ? (isExternalLink ? '_blank' : (menuItem.linkTarget ?? '_self')) : null"
                  [attr.rel]="hasLink && isExternalLink ? 'noopener noreferrer' : null"
                  [attr.role]="!hasLink && hasChildren ? 'button' : null"
                  [attr.tabindex]="!hasLink && hasChildren ? 0 : null"
                  [attr.aria-haspopup]="!hasLink && hasChildren ? 'menu' : null"
                  [attr.aria-expanded]="!hasLink && hasChildren ? dropdownComp.opened() : null"
                  [attr.aria-disabled]="!hasLink && !hasChildren ? true : null"
                  [ngClass]="[
                    isCurrentPage ? menuItemActiveClasses : '',
                    !hasLink && !hasChildren ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
                  ]"
                  [style.paddingTop.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 15"
                  [style.paddingBottom.px]="menubar.verticalPadding ?? defaultMenubar?.verticalPadding ?? 15"
                  (keydown)="headerService.handleDropdownKeydown(dropdownComp, $event, menuItem)"
                  class="focus-visible:ring-primary-main inline-flex items-center gap-1 pl-1 focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 md:gap-1.5"
                >
                  <span
                    [ngClass]="{
                      underline: isCurrentPage && (menubar.activeUnderlined ?? defaultMenubar?.activeUnderlined ?? false)
                    }"
                  >
                    {{ menuItem.label }}
                  </span>
                  @if (menuItem.items.length > 0) {
                    <gs-icon
                      [ngClass]="[
                        styleService.getColorClass(actions?.iconColor ?? defaultMainbar?.actions?.iconColor ?? 'secondary-main', 'text')
                      ]"
                      class="text-sm"
                      [iconName]="dropdownComp.opened() ? 'caret-up' : 'caret-down'"
                      iconWeight="light"
                    ></gs-icon>
                  }
                </a>
                <dropdown
                  #dropdownComp
                  [items]="menuItem.items"
                  [openSubmenusInline]="false"
                  [showItemPhotos]="false"
                  [showItemGlyphs]="false"
                  [menuItemClasses]="dropdownMenuItemFont + ' px-4 py-2'"
                  [menuItemColorClasses]="dropdownMenuItemColors"
                  [activeMenuItemClasses]="dropdownMenuActiveClasses"
                  [hoverMenuItemClasses]="dropdownMenuHoverClasses"
                  [activeUnderlined]="
                    dropdownMenu?.activeUnderlined ??
                    defaultDropdownMenu?.activeUnderlined ??
                    menubar.activeUnderlined ??
                    defaultMenubar?.activeUnderlined ??
                    false
                  "
                  [menuClasses]="styleService.getColorClass(headerBackgroundColor, 'bg') + ' shadow-md min-w-48 py-1'"
                  [ariaLabel]="menuItem.label + ' menu'"
                  [style.fontSize.px]="dropdownMenu?.textSize ?? defaultDropdownMenu?.textSize"
                ></dropdown>
              </li>
            }
            @case (headerService.MenuType.Highlight) {
              <!-- TODO: Highlighted Menu Items coming soon -->
            }
          }
        }
      }
    </ul>
  }
  <ng-template #burgerButtonRef let-showOnlyMobile="showOnlyMobile">
    @if (menubar && menubar.burgerButton && menubar.burgerButton.active) {
      @let burgerButtonIcon =
        menubar.burgerButton.icon ??
        defaultMenubar?.burgerButton?.icon ?? {
          name: 'list',
          weight: 'fill'
        };
      @let burgerButtonColor = menubar.burgerButton.color ?? defaultMenubar?.burgerButton?.color ?? 'secondary-main';
      @let menuActiveTextColor = menubar.activeTextColor ?? defaultMenubar?.activeTextColor ?? 'secondary-main';
      <button
        class="focus-visible:ring-primary-main cursor-pointer border-none bg-transparent duration-200 focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 lg:mr-0"
        (click)="system.toggleSidebar()"
        aria-controls="sidebar-nav"
        [attr.aria-expanded]="system.sidebarOpen()"
        [attr.aria-label]="(system.sidebarOpen() ? 'header.sideBar.closeMenu' : 'header.sideBar.openMenu') | translate"
        [ngClass]="[
          styleService.getColorClass(burgerButtonColor, 'text'),
          styleService.getColorClass(menuActiveTextColor, 'text', 'hover:'),
          showOnlyMobile ? 'flex lg:hidden' : 'flex'
        ]"
        [style.marginLeft.px]="showOnlyMobile ? (isMobile ? 22 : (actions?.gap ?? defaultMainbar?.actions?.gap ?? 15)) : 0"
        [style.marginRight.px]="showOnlyMobile ? 8 : null"
      >
        <gs-icon [iconName]="burgerButtonIcon.name" [iconWeight]="burgerButtonIcon.weight" [animation]="burgerButtonIcon.animation"></gs-icon>
      </button>
    }
  </ng-template>
</nav>

<!-- SIDEBAR -->
<header-sidebar></header-sidebar>

<!-- MYCHAINSTORE PANEL -->
@if (mainbar?.myChainstore?.active) {
  <my-chainstore></my-chainstore>
}
